import spesifisitet from "../../../../static/img/spesifisitet.png";
import bolgeAccent from "../../../../static/img/bolge-accent.png";
import eksempeldesign from "../../../../static/img/eksempeldesign.png";
import * as React from 'react';
export default {
  spesifisitet,
  bolgeAccent,
  eksempeldesign,
  React
};